<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">

            <el-form-item class="form-title" prop="vc_name" label="名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" label="添加字段" style="width: 350px">
                <el-switch v-model="isDt" :active-value="1" :inactive-value="0"  :disabled="!canEdit"></el-switch>
            </el-form-item>
            <el-table border ref="sgtable1" size="mini" :data="formData.dynamicColumn" :height="tableHeight" v-if="isDt"
                      :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
                <el-table-column  prop="lable" label="lable"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input v-if="canEdit" v-model="scope.row.lable" size="mini" placeholder="请输入"></el-input>
                        <div class="mrA" v-else>{{scope.row.lable}}</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="prop" label="prop"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input v-if="canEdit" v-model="scope.row.prop" size="mini" placeholder="请输入"></el-input>
                        <div class="mrA" v-else>{{scope.row.prop}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="40" align="center">
                    <template slot="header" slot-scope="scope" v-if="canEdit">
                        <el-button  icon="el-icon-plus"  @click="addRow"   size="mini" v-if="canEdit" type="text" ></el-button>
                        <!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                    </template>
                    <template slot-scope="scope">
                        <el-button  icon="el-icon-minus" type="text"  v-if="canEdit&&scope.row.i_id==0" @click="deleteRow(scope.row,scope.$index)"  size="mini"></el-button>
                        <!--                    <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>-->
                    </template>
                </el-table-column>
            </el-table>

        </el-form>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "AddItem",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    dynamicColumn:[],
                },
                isDt:0,
                canEdit:false,
                disabled:false,
                dzList:[],
                rules:{
                    vc_name:[{required: true,message:'名称不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            // this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.type=='add'){
                this.canEdit=true;
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            addRow(row,index){
                this.formData.dynamicColumn.unshift({
                    i_id:0,
                    vc_name:'',
                })
            },
            deleteRow(row,index){
                this.formData.dynamicColumn.splice(index,1);
                // if(row.id!=0)this.formData.delgoods.push(row.id);
                // this.getSum(row,index)
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        // if(this.data.type=='add'){
                            this.addItemType()

                        // }else{
                        //     this.editItem()
                        // }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
            },

            //新增
            async addItemType(){
                this.disabled=true

                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addItemType(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.disabled=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>